import { createElement, installComponent } from '../utils/createElement';

export default class SideNavYourAccount extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
  }

  get _event() {
    return new CustomEvent('your-account', { bubbles: true, cancelable: false, composed: true });
  }

  connectedCallback() {
    const styles = createElement('style', null, `
      .sb-sidenav-your-account {
        font-family: proxima-nova, sans-serif;
        color: white;
        display: flex;
        align-items: center;
        padding: 1rem;
        text-decoration: none;
      }
      .sb-sidenav-your-account__image {
        width: 1.75rem;
        height: 1.75rem;
        background: white;
        border-radius: 50%;
        padding: 0.125rem;
      }
      .sb-sidenav-your-account__title {
        margin: 0 0 0 0.25rem;
        font-size: 1rem;
      }
    `);

    const image = createElement('img', { src: 'https://uiassets-afd.shipbob.com/legacyuiassets/webassets/dashboard/images/ShipBob-Logomark-Color.png', class: 'sb-sidenav-your-account__image' });
    const text = createElement('h1', { class: 'sb-sidenav-your-account__title' }, 'Your Account');

    const root = createElement('a', { class: 'sb-sidenav-your-account', href: '#' }, [image, text]);

    root.addEventListener('click', (e) => {
      e.preventDefault();
      // eslint-disable-next-line no-underscore-dangle
      this.dispatchEvent(this._event);
    });

    this.shadowRoot.append(root, styles);
  }
}
installComponent('sb-sidenav-your-account', SideNavYourAccount);
